import CustomModal from './customModal';
import styles from '../css/promoCodeAddedModal.module.scss';
import { useTranslation } from 'react-i18next';

const PromoCodeAddedModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const { t } = useTranslation();

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={() => {
        onClose();
      }}
      closeButton
    >
      <div className={styles.wrap}>
        <p className={styles.title}>{t('promoCodeAddedModal.title')}</p>
        <div className={styles.greenArea}>
          <img src="/assets/images/white-checkmark.svg" alt="checkmark" style={{ width: '22px', height: '22px' }} />
          <p>{t('promoCodeAddedModal.message')}</p>
        </div>
      </div>
    </CustomModal>
  );
};
export default PromoCodeAddedModal;
